import AdminCreate from '@/views/admin/Create.vue'
import AdminList from '@/views/admin/List.vue'
import AdminManage from '@/views/admin/Manage.vue'

// This file deviates from the usual convention of route naming used throughout the project.
// The short names of routes use a letter 'b' for Boss, instead of 'a' for Admin, because 'a' is used for appointments

export default [
  {
    path: '/bc',
    name: 'admin-create',
    component: AdminCreate,
    meta: {
      auth: ['admin'],
      breadcrumbs: [
        {
          link: 'admin-list',
          title: 'Admins'
        },
        {
          link: 'admin-create',
          title: 'New Admin'
        }
      ],
      topbarGroup: 'users'
    }
  },
  {
    path: '/bl',
    name: 'admin-list',
    component: AdminList,
    meta: {
      auth: ['admin'],
      breadcrumbs: [
        {
          link: 'admin-list',
          title: 'Admins'
        }
      ],
      topbarGroup: 'users'
    }
  },
  {
    path: '/bm/:id',
    name: 'admin-manage',
    component: AdminManage,
    meta: {
      auth: ['admin'],
      breadcrumbs: [
        {
          link: 'admin-list',
          title: 'Admins'
        },
        {
          link: 'admin-single',
          title: 'Admin Manage',
          params: 'id'
        }
      ],
      topbarGroup: 'users'
    }
  }
]
